/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Button, Col, FormGroup, Label, Input } from 'reactstrap'

import { AppContext } from '../AppContext'

class EnterAuthCode extends React.Component
{
  constructor(props)
  {
    super();

    this.state =
    {
      authorizationCode: null,
      buttonDisabled: true
    }

    this.setAuthCode = this.setAuthCode.bind(this);
    this.validateAuthCode = this.validateAuthCode.bind(this);
  }

  render()
  {
    document.title = this.context.websiteProfile.profileName + ': Login Auth Code';

    return (
      <div>
        <h1>Secure MFA Authorization</h1>
        <FormGroup row>
          <Label for='authorizationCode' sm="2" >Login Authorization Code</Label>
          <Col sm="1" >
            <Input type="text" id="authorizationCode" value={this.state.authorizationCode} autoFocus={true} 
                onChange={this.setAuthCode}
            />
          </Col>
          <Col><Button disabled={this.state.buttonDisabled} onClick={this.validateAuthCode} color="primary">Authorize</Button></Col>
        </FormGroup>
      </div>
    )
  }

  setAuthCode(event)
  {
    let buttonDisabled = 6 === event.target.value.trim().length ? false : true;
    this.setState({authorizationCode: event.target.value.trim(), buttonDisabled});
  }

  async validateAuthCode()
  {
    let bodyData = {};
    bodyData.confirmationToken = this.state.authorizationCode;

    let result = await this.context.dbTwig.callRestAPI('icam', 'validateLoginAuthCode', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Login authorization failed');
    switch (result.jsonData.sessionStatus)
    {
      case 'active':
      case 'change password':
        this.context.postNotification('success', 'Login authorization successful');
        this.context.authorize(result.jsonData);
        break;

      case 'session limit':
        this.context.postNotification('info', 'You are logged in but your session is blocked');
        this.context.authorize(result.jsonData);
        break;

      default:
        break;
    }
  }
}

EnterAuthCode.contextType = AppContext;

export default EnterAuthCode